import * as React from "react";
import { componentTranslations } from "./i18n";
import Icon from "./icon";
import { FlexContainer } from "../grid/flexcontainer";
import { cx, css } from "emotion";
import { getThemeColorVar } from "../helper/color";
function wrapNavigate(navigateTo) {
    return (event) => {
        event.stopPropagation();
        event.preventDefault();
        navigateTo && navigateTo();
    };
}
const breadcrumb = css({
    listStyle: "none",
    margin: 0,
    a: {
        color: getThemeColorVar("typo", "default"),
        transition: "color .0s ease-out",
        "&:hover": {
            color: getThemeColorVar("primary", "default"),
            textDecoration: "none",
        },
    },
});
const breadcrumbList = css({
    paddingLeft: "5px",
    margin: 0,
});
const breadcrumbItem = css({
    display: "inline-block",
    textTransform: "uppercase",
    fontWeight: 300,
});
const breadcrumbItemLast = css({
    fontWeight: 400,
});
export const Breadcrumb = (props) => {
    const translate = componentTranslations();
    return (React.createElement("div", { className: cx(breadcrumb) },
        React.createElement(FlexContainer, null,
            React.createElement("div", null,
                translate.breadcrumb.title,
                ":"),
            React.createElement("ul", { className: cx(breadcrumbList) }, props.crumbs.map((crumb, idx) => idx === props.crumbs.length - 1 ? (React.createElement("li", { key: idx, className: cx([breadcrumbItem, breadcrumbItemLast]) },
                idx > 0 && React.createElement(Icon, { name: "chevron_right_small" }),
                crumb.label)) : (React.createElement("li", { key: idx, className: cx(breadcrumbItem) },
                idx > 0 && React.createElement(Icon, { name: "chevron_right_small" }),
                React.createElement("a", { href: "", onClick: wrapNavigate(crumb.navigateTo) }, crumb.label))))))));
};
export default Breadcrumb;
//# sourceMappingURL=breadcrumb.js.map